export default {
  name: `loading_screen`,
  loadingText: `تحميل`,
}